import { render, staticRenderFns } from "./SummaryContents-General.vue?vue&type=template&id=0272e3f8&"
import script from "./SummaryContents-General.vue?vue&type=script&lang=js&"
export * from "./SummaryContents-General.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports